<template>
  <form-select
    class="version-select"
    v-model="val"
    :options="options"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'version-select',
  props: {
    version: { type: Array, default: () => [] },
    value: String,
    queryObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  model: {
    prop: 'value',
    event: 'setval'
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      }
    }
  },
  data() {
    return {
      options: []
    }
  },

  methods: {
    arr2Options(arr) {
      var options = []
      if (Array.isArray(arr)) {
        for (var item of arr) {
          options.push({ label: 'V' + item, value: item })
        }
      }

      return options
    }
  },
  watch: {
    queryObj() {
      this.options = this.arr2Options(this.version)
      const currentVersion = this.options[0] ? this.options[0].value : ''
      this.val = currentVersion
      this.$nextTick(() => {
        this.$emit('change', currentVersion)
      })
    }
  }
}
</script>
<style lang="less">
.version-select {
  width: 100px;
}
</style>
